import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { encryptAES } from ".";
import styles from "./DrawerIframe.module.scss";
import { TTP_NACNAI_URL } from "../../../config";

const prepareIframeParams = (user, token, lng) => {
  let params = {};
  if (user && token) {
    ((params["userId"] = user.id), (params["token"] = token));
  }
  if (lng) {
    params["lng"] = lng;
  }
  params["app"] = "UA";

  return encryptAES(JSON.stringify(params));
};

const getViewParam = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return new URLSearchParams(window.location.search).get("view");
};

const ChatBotIframe = ({ lng }) => {
  const { token, user } = useSelector((state) => state.auth);
  const iParams = prepareIframeParams(user, token, lng);
  const view = getViewParam();

  const src =
    `${TTP_NACNAI_URL}` +
    "?params=" +
    encodeURIComponent(iParams) +
    (view ? "&view=" + encodeURIComponent(view) : "");

  return (
    <iframe
      id="drawer_iframe"
      allow="allow-scripts allow-same-origin allow-forms allow-popups clipboard-read clipboard-write allow-popups-to-escape-sandbox allow-top-navigation payment"
      className={styles.iframe}
      src={src}
      title="TAMTAM portal"
      onLoad={() => {
        if (document.getElementById("iframe-loader")) {
          document.getElementById("iframe-loader").style.display = "none";
        }
      }}
    />
  );
};

export default ChatBotIframe;
